<template>
  <div id="app">
    <div class="header" id="header">
      <div class="width-wrapper relative">
        <nav class="top-nav">
          <a href="" @click.prevent="$router.push('/pharmacies/')" class="top-nav__link">Аптеки</a>
          <a href="" @click.prevent="$router.push('/products/')" class="top-nav__link"  v-if="user.role == 'HM'">Товары</a>
          <a href="" @click.prevent="$router.push('/reports/')" class="top-nav__link" v-if="user.role == 'HM'">Отчеты и отправка</a>
          <a href="" @click.prevent="$router.push('/users/')" class="top-nav__link" v-if="user.role == 'HM'">Сотрудники</a>
        </nav>
        <div class="user-info"  v-if="$auth.ready()">
          <a href="#" class="header-notificatons"></a>
          <div class="user">{{user.email}}
            <a href="#" class="logout_link" v-on:click.prevent="$auth.logout(); $router.replace({ path: '/login' });">Выйти</a>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      pageTitle: 'Аптеки',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route(to) {
      this.pageTitle = to.meta.title;
    },
  },
};

</script>


<style src="./assets/generic.less" lang="less"/>






// WEBPACK FOOTER //
// App.vue?2429fd36